import React from 'react';
import { Layout } from 'antd';
import { APP_VERSION } from '../../../../version';
import './footer.css';

const { Footer: AntFooter } = Layout;

/**
 * Uygulama alt bandı — marka imzası.
 * Beyaz etiket kurulumunda bile ürünün kim tarafından yapıldığı burada görünür; imza kodda
 * koşulsuzdur (marka ayarıyla kaldırılamaz).
 */
export default function Footer() {
    return (
        <AntFooter className="app-footer">
            <div className="app-footer-inner">
                <div className="app-footer-brand">
                    <img src="/favicon-his.svg" alt="" className="app-footer-mark" />
                    <span className="app-footer-name">
                        HIS <span className="app-footer-sub">eCloudPACS</span>
                    </span>
                </div>

                <div className="app-footer-meta">
                    <span className="app-footer-copy">
                        © {new Date().getFullYear()} Kuantum Bulut Bilişim ve Yazılım A.Ş.
                    </span>
                    {/* sürüm — derleme günü (yyyyMMdd); API ile aynı yayında aynı damgayı taşır */}
                    <span className="app-footer-version" title={`Sürüm ${APP_VERSION}`}>
                        v{APP_VERSION}
                    </span>
                    <a
                        className="app-footer-site"
                        href="https://kuantumbulut.com"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <img src="/kuantum-logo.svg" alt="" className="app-footer-site-mark" />
                        kuantumbulut.com
                    </a>
                </div>
            </div>
        </AntFooter>
    );
}
